import { DepthType } from "../types/ses/sesItemConfigTypes";

// преобразование цисловой глубины поиска в строковую
const convertSearchDepth = (weight: number): DepthType => {
	let transformedDepth: DepthType = "endpoint";

	if (weight > 10) transformedDepth = "all";
	else if (weight > 1) transformedDepth = "endpoint";
	else transformedDepth = "fresh";

	return transformedDepth;
};

export default convertSearchDepth;
